export interface Test {
  id: string
  title: string
  description?: string
  passingScore: number
  timeLimit?: number
  isActive: boolean
  createdAt: string
  questions: Question[]
  complianceRule: {
    id: string
    title: string
    category: string
    description: string
  }
}

export interface Question {
  id: string
  questionText: string
  questionType: 'SINGLE_CHOICE' | 'MULTIPLE_CHOICE' | 'TRUE_FALSE' | 'ESSAY'
  options: string[]
  points: number
}

export interface TestResult {
  id: string
  score: number
  passed: boolean
  passingScore: number
  attempt: number
  canRetake: boolean
  detailedResults: QuestionResult[]
}

export interface QuestionResult {
  questionId: string
  userAnswer: string
  correctAnswer: string
  isCorrect: boolean
  points: number
  explanation: string
}

export interface TestSubmission {
  testId: string
  userId: string
  enrollmentId: string
  answers: { [questionId: string]: string }
  startedAt: string
}

export interface TestGenerationRequest {
  complianceRuleId: string
  questionCount: number
  difficulty: 'easy' | 'medium' | 'hard'
  userId?: string
  splitOption?: 'multiple' | 'combined'
}

// 長いコンテンツの閾値（A4 5ページ相当）
export const LONG_CONTENT_THRESHOLD = 7500
